import { render, staticRenderFns } from "./GroupInvitationView.vue?vue&type=template&id=35d00b42&scoped=true&"
import script from "./GroupInvitationView.vue?vue&type=script&lang=js&"
export * from "./GroupInvitationView.vue?vue&type=script&lang=js&"
import style0 from "./GroupInvitationView.vue?vue&type=style&index=0&id=35d00b42&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d00b42",
  null
  
)

export default component.exports